import { createSelector } from 'reselect'
import { AppState } from 'store/store'

/**
 * @param state - the application state
 * @returns shifts - the selected shift reducer
 */
export const selectSelectedShiftReducer = (state: AppState) => state.selectedShift

/**
 * Gets the selected shift's data from the selected shift reducer
 */
export const selectSelectedShift = createSelector(
  selectSelectedShiftReducer,
  (selectedShiftReducer) => selectedShiftReducer.data
)

/**
 * Gets the selected shift's meta from the selected shift reducer
 */
export const selectSelectedShiftMeta = createSelector(
  selectSelectedShiftReducer,
  (selectedShiftReducer) => selectedShiftReducer.meta
)

/**
 * Gets the selected shift's isFetching from the selected shift reducer
 */
export const selectSelectedShiftIsFetching = createSelector(
  selectSelectedShiftReducer,
  (selectedShiftReducer) => selectedShiftReducer.isFetching
)

/**
 * Gets the selected shift's error from the selected shift reducer
 */
export const selectSelectedShiftError = createSelector(
  selectSelectedShiftReducer,
  (selectedShiftReducer) => selectedShiftReducer.error
)

/**
 * Gets the shift open positions from the selected shift reducer
 * We need to subtract the accepted count from the total count of positions for the shift to find the total number of open positions.
 */
export const selectSelectedShiftOpenPositions = createSelector(
  selectSelectedShift,
  (shiftState) => {
    const availablePositions = shiftState.positions - shiftState.applicants.accepted_count
    if (availablePositions < 0) {
      return 0
    }
    return availablePositions
  }
)

/**
 * Gets the selected shift's shiftNotes from the selected shift reducer
 */
export const selectSelectedShiftShiftNotes = createSelector(
  selectSelectedShiftReducer,
  (selectedShiftReducer) => selectedShiftReducer.shiftNotes
)
